// extracted by mini-css-extract-plugin
module.exports = {"UserPanelDropdown":"UserPanelDropdown_UserPanelDropdown__J48Wi","Active":"UserPanelDropdown_Active__3f6uu"};